import React from "react";
import { ConfirmationModal, ErrorModal } from "@folio/stripes/components";
import { useIntl } from "react-intl";
/** Confirmation and error dialogs of the product delete flow. */
export var ProductDeleteModals = function (_a) {
    var state = _a.state;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement(React.Fragment, null,
        state.isConfirmOpen && (React.createElement(ConfirmationModal, { open: true, heading: formatMessage({
                id: "ui-br-agency.product.delete.modal.heading",
            }), message: state.confirmMessage, onConfirm: state.confirmDelete, onCancel: state.cancelDelete, isConfirmButtonDisabled: state.isDeleting, confirmLabel: formatMessage({ id: "ui-br-agency.button.delete" }), cancelLabel: formatMessage({ id: "ui-br-agency.button.cancel" }), buttonStyle: "danger" })),
        state.errorMessage && (React.createElement(ErrorModal, { open: true, label: formatMessage({ id: "ui-br-agency.modal.label.error" }), content: state.errorMessage, onClose: state.closeError }))));
};
